import { render } from "./ModifyPeppolItem.vue?vue&type=template&id=3e9e2afc&scoped=true"
import script from "./ModifyPeppolItem.vue?vue&type=script&lang=js"
export * from "./ModifyPeppolItem.vue?vue&type=script&lang=js"

import "./ModifyPeppolItem.vue?vue&type=style&index=0&id=3e9e2afc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9e2afc"]])

export default __exports__